// extracted by mini-css-extract-plugin
export default {"fetchMoreWrapper":"FetchMore_fetchMoreWrapper__9Xzmm","fetchMoreButton":"FetchMore_fetchMoreButton__gbZEF"};